import { BiTargetLock, BiStreetView, BiExit } from 'react-icons/bi';
import { Input, Modal, Space, Form } from 'antd'
import { useState } from 'react';

import { useLocalizacao } from '../providers/Localizacao';
import { useLogin } from '../providers/Login';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
	const [isModalVisibleLocation, setIsModalVisibleLocation] = useState(false)
	const [form] = Form.useForm()
	const [localLocalizacao, setLocalLocalizacao] = useState({
		lat: null,
		lng: null
	})

	const { localizacao, setarLocalizacao } = useLocalizacao()
	const { logout } = useLogin()

	const handleLocalizar = () => {
		form.validateFields().then(values => {
			setarLocalizacao(values)
			setIsModalVisibleLocation(false)
			form.resetFields()
		})
			.catch(info => {
				console.log('Validate Failed:', info);
			});
	}

	const onChange = (e) => {
		if (e.target.id === 'lat') {
			const latLng = e.target.value.split(' ')
			if (latLng.length === 2) {
				form.setFieldsValue({ lat: parseFloat(latLng[0]) })
				form.setFieldsValue({ lng: parseFloat(latLng[1]) })
			}
		}
	}

	return (
		<>
			<nav>
				<li onClick={() => window.open(`http://maps.google.com/maps?q=&layer=c&cbll=${localizacao.lat},${localizacao.lng}`)}><BiStreetView /></li>
				<li onClick={() => setIsModalVisibleLocation(true)}><BiTargetLock /></li>
				<li onClick={() => logout()}><BiExit /></li>
			</nav>
			<Modal title="Localização" visible={isModalVisibleLocation} okText="Localizar" cancelText="Cancelar" onOk={() => handleLocalizar()} onCancel={() => setIsModalVisibleLocation(false)}>
				<Form form={form} layout="horizontal" labelCol={{ span: 8, }} wrapperCol={{ span: 16, }} initialValues={{ remember: true, }} autoComplete="off">
					<Form.Item label="Latitude" name="lat" value={localLocalizacao.lat} rules={[{ required: true, message: 'Por favor preencha a latitude!', },]}>
						<Input onChange={onChange} />
					</Form.Item>
					<Form.Item label="Longitude" name="lng" value={localLocalizacao.lng} rules={[{ required: true, message: 'Por favor preencha a longitude!', },]}>
						<Input />
					</Form.Item>
				</Form>
			</Modal>
		</>
	)

}